import { useCallback, useEffect, useRef, useState } from 'react'

import {
  getMillisecondsUntilNextServiceDay,
  getServiceDate,
} from '../utils/serviceDate'

export default function useServiceDate() {
  const [serviceDate, setServiceDate] = useState(() => getServiceDate())
  const boundaryTimerRef = useRef(null)

  const refresh = useCallback(() => {
    const nextServiceDate = getServiceDate()
    setServiceDate((current) => current === nextServiceDate ? current : nextServiceDate)
  }, [])

  useEffect(() => {
    const scheduleBoundary = () => {
      clearTimeout(boundaryTimerRef.current)
      boundaryTimerRef.current = setTimeout(() => {
        refresh()
        scheduleBoundary()
      }, getMillisecondsUntilNextServiceDay())
    }

    const refreshAfterReturn = () => {
      if (document.visibilityState && document.visibilityState !== 'visible') return
      refresh()
      scheduleBoundary()
    }

    scheduleBoundary()
    window.addEventListener('focus', refreshAfterReturn)
    document.addEventListener('visibilitychange', refreshAfterReturn)

    return () => {
      clearTimeout(boundaryTimerRef.current)
      window.removeEventListener('focus', refreshAfterReturn)
      document.removeEventListener('visibilitychange', refreshAfterReturn)
    }
  }, [refresh])

  return serviceDate
}
